import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultSignageIf } from '../interfaces/SignageIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C704SignageDeleteProps {
  execSignageDelete: (signageId: string) => Promise<ResultSignageIf>
  loading: loadStatus
}
// C704 サイネージ削除API呼出
export const useC704SignageDelete = (): C704SignageDeleteProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildUrl } = useApiUrl()
  const execSignageDelete = async (signageId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      const response = await axios.delete(`${buildUrl(apiUrl.signagesPath)}${signageId}`, {
        headers: header,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execSignageDelete, loading }
}
